export default __webpack_public_path__ + "static/media/cripple1.8ed667e6.png";